import { render, staticRenderFns } from "./health-reportList.vue?vue&type=template&id=17253a6e&scoped=true"
import script from "./health-reportList.vue?vue&type=script&lang=js"
export * from "./health-reportList.vue?vue&type=script&lang=js"
import style0 from "./health-reportList.vue?vue&type=style&index=0&id=17253a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17253a6e",
  null
  
)

export default component.exports